const BUILD_VERSION_HEADER = "x-build-version";
const DEPLOY_TIMESTAMP_HEADER = "x-deploy-timestamp";

type VersionListener = (serverVersion: string, deployTimestamp: number) => void;

let listener: VersionListener | null = null;

export function setVersionListener(fn: VersionListener): void {
    listener = fn;
}

function onVersionHeader(serverVersion: string, deployTimestamp: number): void {
    if (serverVersion && listener) {
        listener(serverVersion, deployTimestamp);
    }
}

export function checkVersionHeader(headers: Headers): void {
    const serverVersion = headers.get(BUILD_VERSION_HEADER);
    const deployTimestamp = headers.get(DEPLOY_TIMESTAMP_HEADER);
    if (serverVersion && deployTimestamp) {
        onVersionHeader(serverVersion, Number(deployTimestamp));
    }
}

export function checkVersionHeaderFromAxios(headers: Record<string, string>): void {
    const serverVersion = headers[BUILD_VERSION_HEADER];
    const deployTimestamp = headers[DEPLOY_TIMESTAMP_HEADER];
    if (serverVersion && deployTimestamp) {
        onVersionHeader(serverVersion, Number(deployTimestamp));
    }
}
